/* ---- json (lottie) animation ---- */
class JsonAnimation extends HTMLElement {
  constructor() {
    (super(),
      (this.animation = null),
      (this.currentUrl = null),
      (this.observer = null),
      (this.resizeTimeout = null),
      (this._initialized = !1),
      (this._onResize = this._onResize.bind(this)),
      (this._onClick = this._onClick.bind(this)));
  }
  connectedCallback() {
    if (!this._initialized) {
      if (
        ((this._initialized = !0),
        !window.lottie || !window.lottie.loadAnimation)
      ) {
        console.warn("<json-animation> requires lottie-web to be loaded.");
        return;
      }
      if (
        ((this.desktopUrl =
          this.getAttribute("animation-url") ||
          this.dataset.animationUrl ||
          ""),
        (this.mobileUrl =
          this.getAttribute("animation-url-mobile") ||
          this.dataset.animationUrlMobile ||
          ""),
        !this.desktopUrl)
      ) {
        console.warn("<json-animation> missing animation-url");
        return;
      }
      ((this.loop = this._getBoolAttr("loop", !0)),
        (this.autoplay = this._getBoolAttr("autoplay", !0)),
        (this.clickToPlay = this._getBoolAttr("click-to-play", !1)),
        (this.speed =
          parseFloat(this.getAttribute("speed") || this.dataset.speed) || 1),
        this.clickToPlay &&
          ((this.style.cursor = "pointer"),
          this.addEventListener("click", this._onClick)),
        this._loadAnimation(),
        window.addEventListener("resize", this._onResize));
    }
  }
  disconnectedCallback() {
    (window.removeEventListener("resize", this._onResize),
      this.removeEventListener("click", this._onClick),
      this.observer && (this.observer.disconnect(), (this.observer = null)),
      this.animation && (this.animation.destroy(), (this.animation = null)),
      clearTimeout(this.resizeTimeout));
  }
  _getBoolAttr(t, e) {
    if (!this.hasAttribute(t)) return e;
    let i = this.getAttribute(t);
    return "" === i || null === i || "true" === i || "1" === i;
  }
  _isMobile() {
    return window.innerWidth < 750;
  }
  _getAnimationUrl() {
    return this._isMobile() && this.mobileUrl
      ? this.mobileUrl
      : this.desktopUrl;
  }
  _onResize() {
    (clearTimeout(this.resizeTimeout),
      (this.resizeTimeout = setTimeout(() => {
        this._loadAnimation();
      }, 250)));
  }
  _onClick() {
    this.animation &&
      (this.animation.isPaused
        ? this.animation.play()
        : this.animation.pause());
  }
  _setupObserver() {
    (this.observer && (this.observer.disconnect(), (this.observer = null)),
      this.autoplay ||
        ((this.observer = new IntersectionObserver(
          (t) => {
            t.forEach((t) => {
              this.animation &&
                (t.isIntersecting
                  ? (this.animation.play(),
                    this.loop || this.observer.unobserve(this))
                  : this.loop && this.animation.pause());
            });
          },
          { threshold: 0.3 },
        )),
        this.observer.observe(this)));
  }
  _loadAnimation() {
    let t = this._getAnimationUrl();
    t &&
      ((this.currentUrl === t && this.animation) ||
        ((this.currentUrl = t),
        this.animation && (this.animation.destroy(), (this.animation = null)),
        (this.innerHTML = ""),
        (this.animation = window.lottie.loadAnimation({
          container: this,
          renderer: "svg",
          loop: this.loop,
          autoplay: this.autoplay,
          path: t,
        })),
        this.animation.setSpeed(this.speed),
        this._setupObserver()));
  }
}
customElements.define("json-animation", JsonAnimation);
